// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3QHVe","error":"Textarea_error__3VUpG","readonly":"Textarea_readonly__K8a8V","disabled":"Textarea_disabled__1JZGm"};